import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

export const CategoryPage = ({
  fetchProducts,
  isLoading,
  products,
  addToCart,
  isAdded,
}) => {
  const navigate = useNavigate();
  const { slug } = useParams();

  useEffect(() => {
    if (slug) fetchProducts(slug);
  }, [slug]);

  useEffect(() => {
    if (isAdded) fetchProducts(slug);
  }, [isAdded]);

  // ✅ products from Redux is already the flat list for this slug
  // It could be an array directly, or nested — handle both shapes
  const productList = Array.isArray(products)
    ? products
    : products?.products || products?.data || [];

  const categoryName = productList?.[0]?.category?.name || slug;

  return (
    <>
      <div
        className="full-row bg-light overlay-dark py-5"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/banner.png)`,
          backgroundPosition: "center center",
          backgroundSize: "cover",
        }}
      >
        <div className="container">
          <div className="row text-center text-white">
            <div className="col-12">
              <h3 className="mb-2 text-white font-weight-bold">
                {categoryName}
              </h3>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center bg-transparent">
                  <li className="breadcrumb-item">
                    <a href="/" className="text-white">
                      Home
                    </a>
                  </li>
                  <li
                    className="breadcrumb-item active text-white"
                    aria-current="page"
                  >
                    {categoryName}
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>

      <section
        className="products"
        style={{ maxWidth: "1350px", margin: "auto", paddingTop: "30px" }}
      >
        <div className="container">
          {isLoading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-success" role="status" />
            </div>
          ) : productList.length === 0 ? (
            <div className="text-center py-5">No products found.</div>
          ) : (
            <div className="row">
              {productList.map((x) => {
                let benifits = [];
                try {
                  const raw = x?.benefits || x?.benifits;
                  benifits = raw ? JSON.parse(raw) : [];
                } catch {
                  benifits = [];
                }

                return (
                  <div className="col-12 col-md-6 col-lg-4 mb-4" key={x?.id}>
                    <div
                      className="card"
                      style={{ cursor: "pointer" }}
                      onClick={() => navigate(`/product/${x?.slug}`)}
                    >
                      <h3 className="product-title text-center">{x?.name}</h3>
                      <div className="product-wrapper d-flex flex-column flex-md-row">
                        <div className="col-12 col-md-6 benefits-section">
                          <ul className="list-group">
                            {benifits.map((b, i) => (
                              <li className="list-group-item" key={i}>
                                <i className="fa-solid fa-check"></i> {b}
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="col-12 col-md-6 product-image">
                          <img
                            src={
                              x?.image?.startsWith("http")
                                ? x.image
                                : `${process.env.REACT_APP_ASSET_URL}/${x?.image}`
                            }
                            alt={x?.name}
                          />
                        </div>
                      </div>
                      <div className="product-price my-2 text-center">
                        <strong>Retail Price:</strong> ₹ {x?.currentPrice}
                      </div>
                      <div className="text-center mb-3 px-3">
                        <button
                          className="btn btn-success w-100"
                          onClick={(e) => {
                            e.stopPropagation();
                            addToCart({ ProductId: x?.id, quantity: 1 });
                          }}
                        >
                          Order Now
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </section>
    </>
  );
};
